import React from 'react';
import { withAuthenticator } from 'aws-amplify-react';
import Amplify from 'aws-amplify';

import AwsExports from 'config/aws/aws-exports';
import App from 'components/app';
import SignIn from 'components/auth/sign-in';
import RequireNewPassword from 'components/auth/require-new-password';
import ForgotPassword from 'components/auth/forgot-password';
import { awsTheme } from 'components/theme';
import withAppThemeHOC from 'components/theme/with-app-theme-hoc';
import withErrorHandlerHOC from 'components/error-handler/with-error-handler-hoc';
import withAuthEventHandlerHOC from 'components/auth/with-auth-event-handler-hoc';
import Analytics from 'services/analytics';
import withApolloProviderHOC from 'components/app/apollo-provider/with-apollo-provider-hoc';
import withInitialProviderHOC from 'components/app/initial-provider/with-initial-provider-hoc';
import { InitSentry } from '../../services/sentry';

InitSentry();

Amplify.configure(AwsExports.Auth);

Analytics.initialize();

const WithAuthenticatorApp = withAuthenticator(App, {
  theme: awsTheme,
  authenticatorComponents: [
    <SignIn />,
    <RequireNewPassword />,
    <ForgotPassword />
  ]
});

export default withAppThemeHOC(
  withErrorHandlerHOC(
    withInitialProviderHOC(
      withApolloProviderHOC(withAuthEventHandlerHOC(WithAuthenticatorApp))
    )
  )
);
